goog.require('el8.app.setup');
goog.require('el8.appservice.status');
goog.require('el8.data.base');
goog.require('el8.data.currUser');
goog.require('el8.data.practices');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.patients');
goog.require('el8.data.physicians');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.patients');
goog.require('el8.service.tz');
goog.require('el8.template.print.medOrders');
goog.require('el8.util.print');


var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.printMedOrders = {};


el8.main.printMedOrders.init = function(spec) {

    el8.service.urls.init(spec.urls);
    el8.appservice.status.init();

    el8.ptdata.currPatient = el8.ptdata.patients.create(spec.patientObj);
    el8.data.currUser.populate(spec.userObj);
    el8.data.currPractice = el8.data.practices.create(spec.practiceObj);

    var prescribingPhysician = null, supervisingPhysician = null;
    if (spec.prescribingPhysicianObj) {
        prescribingPhysician = el8.data.physicians.create(spec.prescribingPhysicianObj);
    }
    if (spec.supervisingPhysicianObj) {
        supervisingPhysician = el8.data.physicians.create(spec.supervisingPhysicianObj);
    }
    el8.ptdata.medOrders.create(spec.medOrders);
    var singleFormType = spec.singleFormType || null;
    if (singleFormType) {
        $(':input[name="formType"]').val(singleFormType);
    }
    var isFax = (spec.fax === true); // defaults to false

    // orderSetsList is an array of dictionaries:
    // {  'type': 'controlled' or 'prescription' or 'otc' or 'samples',
    //    'order_sets': an array of arrays of order ids, each composing a page to print
    var hasControlledSubstance = false;
    var orderSetsList = spec.orderSetsList.map(function(a) {
        return {
            type: a.type,
            orderSets: a.order_sets.map(function(set) {
                return set.map(function(id) {
                    if (id) {
                        var order = el8.ptdata.medOrders.getById(id);
                        var soyMap = order.asSoyMap();
                        soyMap['isControlled'] = order.getMedication() ?
                            order.getMedication().isControlled() : false;
                        if (soyMap['isControlled']) { hasControlledSubstance = true; }
                        return soyMap;
                    } else {
                        return null;
                    }
                });
            })
        };
    });

    var firstMedOrder = el8.ptdata.medOrders.all()[0];
    var pharmacy = firstMedOrder.getFulfillmentMgr().getLatestPharmacy();

    var getIdentifiersMap = function(p, state) {
        var map = [
            {name: 'NPI', value: p.getNpiNumber()},
            {name: 'License', value: p.getLicenseNumber()},
            {name: 'DEA', value: p.getDeaNumber()},
            {name: 'DPS', value: p.getDpsNumber()}
        ];

        if (state === 'OH') {
            map.push( {name: 'Certificate to Prescribe', value: p.getRxAuthNumber()} );
        }
        else {
            map.push( {name: 'Rx Auth', value: p.getRxAuthNumber()} );
        }

        return _(map).reject(function (i) { return !i['value']; });
    };

    var soyMap = {
        practice: el8.data.currPractice.asSoyMap(),
        patient: el8.ptdata.currPatient.asSoyMap(),
        esignatureUrl: hasControlledSubstance ? '' : spec.esignatureUrl || '', // no esig if order has controlled substance
        signPhysician: prescribingPhysician.asSoyMap(),
        signPhysicianIdentifiers: getIdentifiersMap(prescribingPhysician, el8.data.currPractice.getState()),
        pharmacy: pharmacy ? pharmacy.asSoyMap() : null,
        orderSetsList: orderSetsList,
        fax: isFax,
        nonFillable: spec.nonFillable
    };
    if (supervisingPhysician) {
        $.extend(soyMap, {
            supervisingPhysician: supervisingPhysician.asSoyMap(),
            supervisingPhysicianIdentifiers: getIdentifiersMap(supervisingPhysician, el8.data.currPractice.getState())
        });
    }

    $('.print-content').replaceWith(
        el8.template.print.medOrders.multiTypeContent(soyMap)
    );

    $(':input[name="formType"]').change(function(e) {
        var newFormType = $(this).val();
        var url = el8Globals['PATIENT_PATH']+'print/'+newFormType+'/';
        var orderIdParams= el8.ptdata.medOrders.all().map(function(a) { return 'id[]='+a.getId(); });
        url = url + '?' + orderIdParams.join('&');
        window.location.href = url;
    });

    el8.util.print.pageSetup();
};

